module.exports = __webpack_public_path__ + "img/desjardins.e86cd69f.png";